import { getAdminApiUrl } from '@adsk/acs-sc-web-platform-api';

export const buildRemoveProjectCompanyRequest = (projectId, companyId) => [
  `${getAdminApiUrl()}/v1/projects/${projectId}/companies/${companyId}`,
  {
    method: 'DELETE',
  },
];
